import React, { useState, useEffect } from 'react';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  Nav,
  NavItem,
  NavLink,
  NavbarBrand,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
} from 'reactstrap';
import HamburgerMenu from 'react-hamburger-menu';
import frozberiesLogo from '../images/frozberries-logo.png';
import { connect } from 'react-redux';
import { useLocation, NavLink as NLink } from 'react-router-dom';
import SideBar from './SideBar';
import Cart from './Cart';
import { matchPath } from 'react-router';
import { resetProducts } from '../actions/productsActions';

const NavBar = ({ resetProducts }: any) => {
  const [isOpen, setIsOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(0);
  const [aboutDropdown, setAboutDropdown] = useState(false);
  const [toggleCollapse, setToggleCollapse] = useState(false);

  const location = useLocation();

  const updateWindowDimension = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    setWindowWidth(window.innerWidth);
    window.addEventListener('resize', updateWindowDimension);
    return () => {
      window.removeEventListener('resize', updateWindowDimension);
    };
  }, []);

  const toggleHamburger = () => {
    if (windowWidth < 768) {
      setIsOpen((prev) => !prev);
    }
  };

  const toggleAbout = () => {
    setAboutDropdown((prev) => !prev);
  };

  const toggle = () => {};

  const collapseToggle = () => {
    setToggleCollapse((prev) => !prev);
  };

  const handleShopClick = () => {
    if (windowWidth < 768) {
      toggleHamburger();
    }
    if (location.pathname !== '/shop') {
      resetProducts();
    }
  };

  const hash = window.location.pathname;
  const customMatch = matchPath(hash, {
    path: `/shop/:title/:productid`,
    exact: true,
    strict: false,
  });

  return (
    location.pathname !== '/adminpanel' &&
    location.pathname !== '/checkout' && (
      <div
        style={{
          backgroundColor: 'white',
        }}
      >
        <Navbar expand="md">
          {windowWidth >= 768 && (
            <NavbarBrand href="/">
              <img
                className="img-fluid"
                style={{ height: 50 }}
                src={frozberiesLogo}
                alt="frozberries-logo"
              />
            </NavbarBrand>
          )}

          <NavbarToggler onClick={toggle} className="border-0 mt-2 mr-auto">
            <HamburgerMenu
              isOpen={isOpen}
              navbar
              menuClicked={toggleHamburger}
              borderRadi={0}
              color="rgb(14,35,87)"
              animationDuration={0.5}
            />
          </NavbarToggler>

          {windowWidth < 768 && (
            <NavbarBrand href="/" className="text-center mx-auto animate__bounceIn">
              <img style={{ height: 50 }} src={frozberiesLogo} alt="frozberries-logo" />
            </NavbarBrand>
          )}

          {windowWidth < 768 && <Cart />}

          <Collapse id="nav-collapse" isOpen={isOpen} navbar className="text-center">
            <Nav className="mx-auto font-weight-bold" navbar>
              <NavItem>
                <NavLink
                  style={{
                    color: location.pathname === '/' ? 'white' : 'rgb(14,35,87)',
                    backgroundColor: location.pathname === '/' && 'rgb(236,23,79)',
                    borderRadius: location.pathname === '/' && '30px',
                  }}
                  exact
                  to="/"
                  tag={NLink}
                  onClick={windowWidth < 768 ? toggleHamburger : null}
                >
                  HOME
                </NavLink>
              </NavItem>
              <NavItem onMouseEnter={toggleAbout} onMouseLeave={toggleAbout}>
                {windowWidth >= 768 ? (
                  <Dropdown isOpen={aboutDropdown} toggle={toggle}>
                    <DropdownToggle
                      tag="nav-link"
                      data-toggle="dropdown"
                      aria-expanded={aboutDropdown}
                    >
                      <NavLink
                        style={{
                          color:
                            location.pathname === '/ourstory' ||
                            location.pathname === '/elginorganic'
                              ? 'white'
                              : 'rgb(14,35,87)',
                          backgroundColor:
                            (location.pathname === '/ourstory' ||
                              location.pathname === '/elginorganic') &&
                            'rgb(236,23,79)',
                          borderRadius:
                            (location.pathname === '/ourstory' ||
                              location.pathname === '/elginorganic') &&
                            '30px',
                        }}
                        href="#"
                        className={
                          location.pathname === '/ourstory' || location.pathname === '/elginorganic'
                            ? 'active'
                            : ''
                        }
                      >
                        ABOUT
                      </NavLink>
                    </DropdownToggle>
                    <DropdownMenu className="nav-dropdown-menu text-center border-0">
                      <NavLink
                        href="/ourstory"
                        style={{
                          color: location.pathname === '/ourstory' ? '#f05053' : 'rgb(14,35,87)',
                        }}
                      >
                        OUR STORY
                      </NavLink>
                      <NavLink
                        href="/elginorganic"
                        style={{
                          color:
                            location.pathname === '/elginorganic' ? '#f05053' : 'rgb(14,35,87)',
                        }}
                      >
                        ELGIN ORGANIC
                      </NavLink>
                    </DropdownMenu>
                  </Dropdown>
                ) : (
                  <React.Fragment>
                    <NavLink
                      href="#"
                      style={{
                        color:
                          location.pathname === '/ourstory' || location.pathname === '/elginorganic'
                            ? 'white'
                            : 'rgb(14,35,87)',
                        backgroundColor:
                          (location.pathname === '/ourstory' ||
                            location.pathname === '/elginorganic') &&
                          'rgb(236,23,79)',
                        borderRadius:
                          (location.pathname === '/ourstory' ||
                            location.pathname === '/elginorganic') &&
                          '30px',
                      }}
                      className={
                        location.pathname === '/ourstory' || location.pathname === '/elginorganic'
                          ? 'active'
                          : ''
                      }
                      onClick={collapseToggle}
                    >
                      {toggleCollapse ? (
                        <i
                          style={{ fontSize: '15px', color: 'rgb(14,35,87)' }}
                          className="fas fa-minus pr-2"
                        />
                      ) : (
                        <i
                          style={{ fontSize: '15px', color: 'rgb(14,35,87)' }}
                          className="fas fa-plus pr-2"
                        />
                      )}
                      ABOUT
                    </NavLink>
                    <Collapse isOpen={toggleCollapse}>
                      <NavLink
                        href="/ourstory"
                        style={{
                          fontSize: '15px',
                          color: location.pathname === '/ourstory' ? '#f05053' : 'rgb(14,35,87)',
                        }}
                        onClick={windowWidth < 768 ? toggleHamburger : null}
                      >
                        OUR STORY
                      </NavLink>
                      <NavLink
                        href="/elginorganic"
                        style={{
                          fontSize: '15px',
                          color:
                            location.pathname === '/elginorganic' ? '#f05053' : 'rgb(14,35,87)',
                        }}
                        onClick={windowWidth < 768 ? toggleHamburger : null}
                      >
                        ELGIN ORGANIC
                      </NavLink>
                    </Collapse>
                  </React.Fragment>
                )}
              </NavItem>
              <NavItem>
                <NavLink
                  style={{
                    color: location.pathname === '/shop' || customMatch ? 'white' : 'rgb(14,35,87)',
                    backgroundColor:
                      (location.pathname === '/shop' || customMatch) && 'rgb(236,23,79)',
                    borderRadius: (location.pathname === '/shop' || customMatch) && '30px',
                  }}
                  to="/shop"
                  tag={NLink}
                  onClick={handleShopClick}
                >
                  SHOP
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  style={{
                    color: location.pathname === '/deliverylocations' ? 'white' : 'rgb(14,35,87)',
                    backgroundColor: location.pathname === '/deliverylocations' && 'rgb(236,23,79)',
                    borderRadius: location.pathname === '/deliverylocations' && '30px',
                  }}
                  to="/deliverylocations"
                  tag={NLink}
                  onClick={windowWidth < 768 ? toggleHamburger : null}
                >
                  DELIVERY
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{
                    color: location.pathname === '/contact' ? 'white' : 'rgb(14,35,87)',
                    backgroundColor: location.pathname === '/contact' && 'rgb(236,23,79)',
                    borderRadius: location.pathname === '/contact' && '30px',
                  }}
                  to="/contact"
                  tag={NLink}
                  onClick={windowWidth < 768 ? toggleHamburger : null}
                >
                  CONTACT
                </NavLink>
              </NavItem>
            </Nav>

            <div
              style={{ fontSize: '20px', borderRadius: '99px' }}
              className=" p-2 px-3 shadow-lg contact-icon d-lg-none d-xl-block"
            >
              <a className="phone-link" href="tel:03 9335 6331">
                <i className="fas fa-phone pr-1 "></i>
                03 9335 6331
              </a>
            </div>

            {windowWidth >= 768 && <Cart />}
          </Collapse>

          <SideBar />
        </Navbar>
      </div>
    )
  );
};

const mapStateToProps = (state: any) => ({
  shoppingCart: state.cart,
  products: state.products,
});

export default connect(mapStateToProps, { resetProducts })(NavBar);
